<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h5>Bitrate Converter</h5>
        <bitrate :item="item" />
      </div>
      <!-- div class="col-md-6">
        <h5>File Type Converter</h5>
        <file-type :item="item" />
      </div -->
    </div>
    <div class="row">
      <div class="col-12">
        <hr>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <gain :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
import BitRate from "./Converter/BitRate";
import FileType from "./Converter/FileType";
import Gain from "./Converter/Gain";

Vue.component("bitrate", BitRate);
Vue.component("file-type", FileType);
Vue.component("gain", Gain);

export default {
  name: "Converter",
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.control-label {
  text-align: right;
}
.converter-portlet {
  margin-top: 20px;
  padding: 0 20px 0 20px;
  border: 1px solid #ddd;
  background: #fafafa;

  .portlet-title {
    margin-top: 10px;
    border-bottom: none;
  }
}
</style>
